import heading from './heading';
import subtitle from './subtitle';
import title from './title';

export default { ...heading, subtitle, title };
